import axios from "axios";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

import { SubscriptionInfo } from "../@types/subscriptionInfo";

const SubscriptionService = {
    getInfos: async (): Promise<SubscriptionInfo> => {
        const token = localStorage.getItem("user-token");

        const config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_DELEND_API}/subscriptions/v1/info`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        };

        return axios(config)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                toast.error(error.response.data.errorDescription);
            })
    },
    update: async (subscriptionInfo: any) => {
        const token = localStorage.getItem("user-token");


        var data = JSON.stringify(subscriptionInfo);

        var config = {
            method: "put",
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_DELEND_API}/subscriptions/v1/info`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            data: data,
        };

        return axios(config)
            .then((response) => {
                toast(
                    `Dados enviados com sucesso.`
                );
                return response;
            })
            .catch(function (error) {
                Sentry.captureException(error);
                toast.error(error.response.data.message);
                return error.response.status;
            });
    }
}

export default SubscriptionService;